
            const data = {"name":"feather/video","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"m23 7-7 5 7 5V7z\"/><rect pid=\"1\" x=\"1\" y=\"5\" width=\"15\" height=\"14\" rx=\"2\" ry=\"2\"/>","originalColors":[],"stopColors":[]}}
        
                module.exports = data
                